export const gtag = (...args: any[]) => {
  if (typeof window !== "undefined" && "gtag" in window) {
    (window as any).gtag(...args);
  } else {
    console.warn("gtag not initialized yet:", args);
  }
};
